<mat-toolbar [class.full-size-logo]="settings.HeaderLogoWithoutPaddings" [class.show-logo-only]="showLogoOnly">
  <div class="logo">
    <a
      [routerLink]="[catalog.name, currentLang()]"
      [queryParams]="{ OrderId: adminCartMode() ? orderId() : null }"
      (click)="activeRouteId() !== RouteId.ObjectChoice ? onHomeClick() : null"
    >
      <img [src]="catalog.logoUrl" alt="Home" />
    </a>
    @if (catalog.status === 'Test') {
      <div class="test-mode-hint">{{ 'TEST_MODE_HINT' | translate }}</div>
    }
  </div>
  @if (catalog.environmentName !== 'Production') {
    <div class="environment">{{ catalog.environmentName }}</div>
  }
  @if (adminCartMode()) {
    <div class="editing-order">
      @if (order(); as order) {
        @if (order.oldId) {
          <div class="old-id" tippy="{{ 'ORDER.OLD_ID' | translate }}: {{ order.oldId }}" translate="ORDER.HAS_OLD_ID"></div>
        }
        <span
          translate="CART.EDIT_ORDER_HEADING"
          [translateParams]="{
            creator: order.customer.firstName + ' ' + order.customer.lastName,
            orderNumber: order.orderNumber,
          }"
        ></span>
      } @else if (cart()?.isBlockCart) {
        <span>{{ 'OBJECT_CHOICE.TITLE_EDIT_BLOCKS' | translate }}</span>
      } @else if (cart()?.hasOrder === false) {
        <span>{{ 'ORDER.TEMP_CART' | translate }}</span>
      }
    </div>
  }
  <div class="icons-wrapper">
    @if (isSmallScreen()) {
      <a
        mat-icon-button
        class="calendar"
        [class.active]="activeRouteId() === RouteId.ObjectChoice"
        [routerLink]="[catalog.name, currentLang()]"
        [queryParams]="{ OrderId: adminCartMode() ? orderId() : null }"
        (click)="activeRouteId() !== RouteId.ObjectChoice ? onHomeClick() : null"
        [tippy]="'NAVIGATION.CHOICES' | translate"
        [attr.aria-label]="'NAVIGATION.CHOICES' | translate"
      >
        <mat-icon fontIcon="date_range"></mat-icon>
      </a>
    } @else {
      <a
        mat-button
        class="calendar"
        [class.active]="activeRouteId() === RouteId.ObjectChoice"
        [routerLink]="[catalog.name, currentLang()]"
        [queryParams]="{ OrderId: adminCartMode() ? orderId() : null }"
        (click)="activeRouteId() !== RouteId.ObjectChoice ? onHomeClick() : null"
        [tippy]="'NAVIGATION.CHOICES' | translate"
        [attr.aria-label]="'NAVIGATION.CHOICES' | translate"
      >
        <mat-icon fontIcon="date_range"></mat-icon>
      </a>
    }
    @if (isSmallScreen()) {
      <a
        mat-icon-button
        class="cart"
        [matBadge]="cartCount()"
        [matBadgeHidden]="(cartCount() ?? 0) <= 0 || activeRouteId() === RouteId.OrderStatus"
        [routerLink]="[catalog.name, currentLang(), 'cart']"
        [queryParams]="{ OrderId: adminCartMode() ? orderId() : null }"
        routerLinkActive="active"
        [tippy]="'NAVIGATION.CART' | translate"
        [attr.aria-label]="'NAVIGATION.CART' | translate"
      >
        <mat-icon fontIcon="shopping_cart"></mat-icon>
      </a>
    } @else {
      <a
        mat-button
        class="cart"
        [matBadge]="cartCount()"
        [matBadgeHidden]="(cartCount() ?? 0) <= 0 || activeRouteId() === RouteId.OrderStatus"
        [routerLink]="[catalog.name, currentLang(), 'cart']"
        [queryParams]="{ OrderId: adminCartMode() ? orderId() : null }"
        routerLinkActive="active"
        [tippy]="'NAVIGATION.CART' | translate"
        [attr.aria-label]="'NAVIGATION.CART' | translate"
      >
        <mat-icon fontIcon="shopping_cart"></mat-icon>
      </a>
    }
    @if (!isSmallScreen() && !isAuthenticated()) {
      <button mat-button class="signin" color="accent" (click)="onLoginClick()">
        {{ 'SIGN_IN' | translate }}
      </button>
    } @else if (isSmallScreen() && !isAuthenticated()) {
      <button mat-icon-button class="signin" color="accent" (click)="onLoginClick()" [tippy]="'SIGN_IN' | translate">
        <mat-icon fontIcon="account_circle"></mat-icon>
      </button>
    }
    @if (!adminCartMode()) {
      @if (isAuthenticated() && user(); as user) {
        @if (!(isSmallScreen() && !isAuthenticated())) {
          <button mat-button class="user-menu button-with-arrow" [matMenuTriggerFor]="toolbarUserMenu">
            <span class="full-name">{{ user.profile?.firstName }} {{ user.profile?.lastName }}</span>
            <div class="arrow-wrapper">
              <div class="arrow"></div>
            </div>
          </button>
        }
        @if (isSmallScreen()) {
          <button mat-icon-button class="user-menu" [matMenuTriggerFor]="toolbarUserMenu">
            {{ $safeNavigationMigration(user.profile?.firstName) | slice: 0 : 1
            }}{{ $safeNavigationMigration(user.profile?.lastName) | slice: 0 : 1 }}
          </button>
        }
        <mat-menu #toolbarUserMenu="matMenu">
          @if (user.isAtLeastJanitor) {
            <a mat-menu-item [routerLink]="[catalog.name, 'Admin']">{{ 'PROFILE_MENU.ADMIN' | translate }}</a>
            <a mat-menu-item [routerLink]="[catalog.name, 'Admin', 'Reservations']">{{ 'PROFILE_MENU.ORDERS' | translate }}</a>
            <mat-divider></mat-divider>

            @switch (catalog.id) {
              @case (catalogIds.palfries) {
                <a mat-menu-item target="_blank" href="/Tenants/Palfries/Pages/Rides?ride=ascent">Bergfahrten</a>
                <a mat-menu-item target="_blank" href="/Tenants/Palfries/Pages/Rides?ride=descent">Talfahrten</a>
                <a mat-menu-item target="_blank" href="/Tenants/Palfries/Pages/Rides?ride=descent&screen=true"
                  >Talfahrten (Bildschirm-Ansicht)</a
                >
                <mat-divider></mat-divider>
              }
              @case (catalogIds.vsbb) {
                <a mat-menu-item target="_blank" href="/Tenants/VSBB/Pages/InfoScreen">Infoscreen</a>
                <mat-divider></mat-divider>
              }
            }
          }
          <button mat-menu-item (click)="openMyOrders()">
            {{ 'MY_ORDERS' | translate }}
          </button>
          <button mat-menu-item (click)="onEditProfileClick()">
            {{ 'PROFILE_MENU.EDIT_PROFILE' | translate }}
          </button>
          <button mat-menu-item (click)="onPasswordChangeClick()">
            {{ 'PROFILE_MENU.CHANGE_PW' | translate }}
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="onLogoutClick()">
            <span>{{ 'PROFILE_MENU.LOGOUT' | translate }}</span>
          </button>
        </mat-menu>
      }
      <app-language-switch></app-language-switch>
    }
  </div>
</mat-toolbar>
